import React from 'react';
var FooterPartnersSub = function (_a) {
    var children = _a.children;
    if (Array.isArray(children)) {
        return (React.createElement("div", { className: "fr-footer__partners-sub" },
            React.createElement("ul", null, children.map(function (child) { return (React.createElement("li", null, child)); }))));
    }
    return (React.createElement("div", { className: "fr-footer__partners-sub" },
        React.createElement("ul", null,
            React.createElement("li", null, children))));
};
export default FooterPartnersSub;
